module.exports = __webpack_public_path__ + "static/media/raise-floor.f109fb4d.png";